// extracted by mini-css-extract-plugin
export default {"container":"CardList_container__EPfbg","cardList":"CardList_cardList__AmB9m"};